import GridLayout from "react-grid-layout";
import {tabletDefaultLayout} from "../../constants/layouts";
import {useWindowSize} from "../../hooks/common/useWindowSize";
import {DraggableItem} from "../../styles/dashboard";
import MarketChanges from "../MarketChanges";
import LastTrades from "../LastTrades";
import TradingChart from "../chart/TradingChart";
import TradingComp from "../tradespot/TradingComp";
import OrdersHistory from "../orders-history/OrdersHistory";
import OrdersBook from "../orderbox/OrdersBook";
import {tourOptions} from "../../constants/tour";
import Tour from "../../packages/tour/Tour";
import {useMainContext} from "../../contexts/main";
import {useTradePrice} from "../../contexts/trade-price";


const Tablet = () => {

    const { width } = useWindowSize()
    const { main: { lang } } = useMainContext()
    const { setActiveSpotTab } = useTradePrice()

    return (
        <Tour options={tourOptions(lang, setActiveSpotTab)}>
            <div style={{ direction: 'ltr'}}>
                <GridLayout
                    className="layout"
                    layout={tabletDefaultLayout}
                    cols={12}
                    rowHeight={10}
                    width={width}
                    margin={[0, 0]}
                    isDraggable={false}
                    isResizable={false}
                >
                    <div key={'last-trades'}>
                        <DraggableItem id={'last-trades'}>
                            <LastTrades />
                        </DraggableItem>
                    </div>

                    <div key={'chart'}>
                        <DraggableItem style={{ overflow: 'hidden' }}>
                            <TradingChart />
                        </DraggableItem>
                    </div>
                    <div key={'spot'}>
                        <DraggableItem id={'spot'}>
                            <TradingComp />
                        </DraggableItem>
                    </div>
                    <div key={'order-book'} style={{ zIndex: 201 }}>
                        <DraggableItem id={'order-book'}>
                            <OrdersBook />
                        </DraggableItem>
                    </div>
                    <div key={'history'} id={'history'}>
                        <DraggableItem >
                            <OrdersHistory />
                        </DraggableItem>
                    </div>
                    <div key={'market-change'} style={{ zIndex: 301 }}>
                        <DraggableItem style={{ overflow: 'visible' }}>
                            <MarketChanges />
                        </DraggableItem>
                    </div>
                </GridLayout>
            </div>
        </Tour>
    )
}

export default Tablet
